import React, { useState, useEffect, useRef } from "react";
import Images from "../../../media/images";
import { fetchBranch } from "../../../features/branch/branchSlice";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../api/api";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form"




const TaskEdit = ({ taskId }) => {
  const branch = useSelector((state) => state.branch);
  const [staff, setStaff] = useState([]);
  const dispatch = useDispatch();
  const { register, handleSubmit, unregister, setValue } = useForm();

  const [searchData, setSearchData] = useState([]);
  // const [results, setResults] = useState({});
  const [cmpId, setCmpId] = useState(null)
  const [taskResult, setTaskResult] = useState([])



  useEffect(() => {
    dispatch(fetchBranch());

  }, []);




  // fetch users
  useEffect(() => {
    api
      .get("/users/?user_type=ST")
      .then((response) => {
        // console.log('response',response.data)
        setStaff(response.data);
      })
      .catch((err) => alert("something went wrong"));
  }, []);


  useEffect(() => {

    taskId !== null && api.get(`tasks/?id=${taskId}`)
      .then(response => {
        // console.log(response.data)
        setTaskResult(response.data)
      }).catch(err => {
        console.log('err', err)
      })
  }, [taskId])



  // fetch company
  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    api
      .get(`/services/company/${item.id}/`)
      .then((response) => {
        // console.log("Result",response.data)
        // setResults(response.data);
        setCmpId(response.data.id)

      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };

  const handleSub = (data) => {
    // console.log('data',data)
    if (cmpId !== null) {
      data.company = cmpId

    }

    api.patch(`/tasks/${taskId}/`, data)
      .then(respone => {
        toast.success("Data updated successfully")
      }).catch(error => {
        toast.error("Something went wrong")
      })
  }




  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  return (
    <div>
      <div className="">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          Edit Task Create
        </h1>
        <div className="">
          <img src={Images.title_border} alt="" className="mx-auto mt-4" />
        </div>
        {/*   */}
        <form className="mt-10 px-3 pb-10 md:!px-10" onSubmit={handleSubmit(handleSub)}>
          <div className="border">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/*  date */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 p-2">
                <label htmlFor="" className="text-primary-red">
                  Task Create Date:
                </label>
                <input
                  type="date"
                  name=""
                  className="flex-grow py-2 px-2 outline-none"
                  id="nepali-datepicker"
                  placeholder="Select Nepali Date"
                  {...register('assigned_at', { required: false }, setValue("assigned_at", taskResult[0]?.assigned_at.split('T')[0]))}
                // { item.assigned_at.split('T')[0] }

                />
              </div>
              {/* pan no */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
                <label htmlFor="" className="text-primary-red">
                  Branch Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <select
                    name=""
                    {...register("branch_code", { required: false }, setValue("branch_code", taskResult[0]?.branch_code))}
                    className="border-primary-blue w-full border p-2"
                  >
                    <option>Select</option>
                    {branch?.data?.map((item, i) => (
                      <option key={i} value={item.code}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* staff name */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0   p-2">
                <label htmlFor="" className="text-primary-red">
                  Staff Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <select
                    name=""
                    className="border-primary-blue outline-none w-full border p-2"
                    // {...register('assigned_to_name', { required: false }, setValue("assigned_to_name", taskResult[0]?.assigned_to_name))}
                    {...register("assigned_to", {required : false}, setValue("assigned_to", taskResult[0]?.assigned_to_name))}
                  >
                                 
                    {staff?.map((item, i) => (
                      <option key={i} value={item.id}>
                        { item.profile.f_name + "  " + item.profile.l_name}
                      </option>
                    ))}


                  </select>
                </div>
              </div>
              {/* company name */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-r-2 border-b-2 border-l-2 md:border-l-0 border-t-0 p-2">
                <label htmlFor="" className="text-primary-red">
                  Assigned Other Company Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">

                  <div className="w-80">
                    <ReactSearchAutocomplete
                      items={searchData}
                      onSearch={handleOnSearch}
                      onHover={handleOnHover}
                      onSelect={handleOnSelect}
                      onFocus={handleOnFocus}
                      autoFocus
                      formatResult={formatResult}
                    />
                  </div>

                </div>
              </div>

              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 p-2">
                <label htmlFor="" className="text-primary-red">
                  Company Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <input
                    type="text"
                    name=""
                    className="flex-grow py-2 px-2 outline-none"

                    placeholder=""
                    disabled
                    value={taskResult[0]?.company_name}
                  // {...register('assigned_at', {required: false})}

                  />
                </div>
              </div>
              
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-r-2 border-l-2 md:border-l-0 border-b-2 p-2">
                <label htmlFor="" className="text-primary-red">
                  Remarks
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <input
                    type="text"
                    name=""
                    className="flex-grow py-2 px-2 outline-none"

                    placeholder=""
                    // disabled
                    // value={taskResult[0]?.company_name}
                  // {...register('assigned_at', {required: false})}

                  />
                </div>
              </div>
              {/* details  */}
            </div>

            <div className="border-primary-blue border-2 border-t-0 p-2 md:col-span-2">
              <div htmlFor="" className="text-primary-red">
                Task/job Details:
              </div>
              <textarea

                {...register("job_details", {
                  required: false,

                },
                  setValue('job_details', taskResult[0]?.job_details)
                )}
                // name=""
                id=""
                cols={30}
                rows={10}
                className="w-full p-3 outline-none"
              // defaultValue={""}
              />
            </div>
          </div>
          {/* save submit btn */}
          <button type="submit" className="bg-primary-green ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
            Save
          </button>

        </form>
      </div>
    </div>
  )
}

export default TaskEdit